/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BareRouteImport } from './routes/_bare'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShamesIndexRouteImport } from './routes/shames/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as PlayersIndexRouteImport } from './routes/players/index'
import { Route as LocationsIndexRouteImport } from './routes/locations/index'
import { Route as LoansIndexRouteImport } from './routes/loans/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as GameNightsIndexRouteImport } from './routes/game-nights/index'
import { Route as CompareIndexRouteImport } from './routes/compare/index'
import { Route as SessionsNewRouteImport } from './routes/sessions/new'
import { Route as PlayersPlayerIdRouteImport } from './routes/players/$playerId'
import { Route as GamesNewRouteImport } from './routes/games/new'
import { Route as GamesGameIdRouteImport } from './routes/games/$gameId'
import { Route as BareRsvpRouteImport } from './routes/_bare/rsvp'
import { Route as BareLoginRouteImport } from './routes/_bare/login'
import { Route as BareAuthCallbackRouteImport } from './routes/_bare/auth-callback'
import { Route as SessionsUpdateSessionIdRouteImport } from './routes/sessions/update_.$sessionId'
import { Route as SessionsNewGameIdRouteImport } from './routes/sessions/new_.$gameId'
import { Route as PlayersPlayerIdSessionsRouteImport } from './routes/players/$playerId_.sessions'
import { Route as GamesImportStartRouteImport } from './routes/games/import/start'
import { Route as GamesGameIdUpdateRouteImport } from './routes/games/$gameId_.update'
import { Route as GamesGameIdSessionsRouteImport } from './routes/games/$gameId_.sessions'
import { Route as GamesImportListUsernameRouteImport } from './routes/games/import/list_.$username'

const BareRoute = BareRouteImport.update({
  id: '/_bare',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShamesIndexRoute = ShamesIndexRouteImport.update({
  id: '/shames/',
  path: '/shames/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersIndexRoute = PlayersIndexRouteImport.update({
  id: '/players/',
  path: '/players/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoansIndexRoute = LoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const GameNightsIndexRoute = GameNightsIndexRouteImport.update({
  id: '/game-nights/',
  path: '/game-nights/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareIndexRoute = CompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsNewRoute = SessionsNewRouteImport.update({
  id: '/sessions/new',
  path: '/sessions/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersPlayerIdRoute = PlayersPlayerIdRouteImport.update({
  id: '/players/$playerId',
  path: '/players/$playerId',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesNewRoute = GamesNewRouteImport.update({
  id: '/games/new',
  path: '/games/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameIdRoute = GamesGameIdRouteImport.update({
  id: '/games/$gameId',
  path: '/games/$gameId',
  getParentRoute: () => rootRouteImport,
} as any)
const BareRsvpRoute = BareRsvpRouteImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => BareRoute,
} as any)
const BareLoginRoute = BareLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => BareRoute,
} as any)
const BareAuthCallbackRoute = BareAuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => BareRoute,
} as any)
const SessionsUpdateSessionIdRoute = SessionsUpdateSessionIdRouteImport.update({
  id: '/sessions/update_/$sessionId',
  path: '/sessions/update/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsNewGameIdRoute = SessionsNewGameIdRouteImport.update({
  id: '/sessions/new_/$gameId',
  path: '/sessions/new/$gameId',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayersPlayerIdSessionsRoute = PlayersPlayerIdSessionsRouteImport.update({
  id: '/players/$playerId_/sessions',
  path: '/players/$playerId/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesImportStartRoute = GamesImportStartRouteImport.update({
  id: '/games/import/start',
  path: '/games/import/start',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameIdUpdateRoute = GamesGameIdUpdateRouteImport.update({
  id: '/games/$gameId_/update',
  path: '/games/$gameId/update',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameIdSessionsRoute = GamesGameIdSessionsRouteImport.update({
  id: '/games/$gameId_/sessions',
  path: '/games/$gameId/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesImportListUsernameRoute = GamesImportListUsernameRouteImport.update({
  id: '/games/import/list_/$username',
  path: '/games/import/list/$username',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-callback': typeof BareAuthCallbackRoute
  '/login': typeof BareLoginRoute
  '/rsvp': typeof BareRsvpRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/games/new': typeof GamesNewRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/compare/': typeof CompareIndexRoute
  '/game-nights/': typeof GameNightsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/loans/': typeof LoansIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/players/': typeof PlayersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shames/': typeof ShamesIndexRoute
  '/games/$gameId/sessions': typeof GamesGameIdSessionsRoute
  '/games/$gameId/update': typeof GamesGameIdUpdateRoute
  '/games/import/start': typeof GamesImportStartRoute
  '/players/$playerId/sessions': typeof PlayersPlayerIdSessionsRoute
  '/sessions/new/$gameId': typeof SessionsNewGameIdRoute
  '/sessions/update/$sessionId': typeof SessionsUpdateSessionIdRoute
  '/games/import/list/$username': typeof GamesImportListUsernameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-callback': typeof BareAuthCallbackRoute
  '/login': typeof BareLoginRoute
  '/rsvp': typeof BareRsvpRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/games/new': typeof GamesNewRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/compare': typeof CompareIndexRoute
  '/game-nights': typeof GameNightsIndexRoute
  '/games': typeof GamesIndexRoute
  '/loans': typeof LoansIndexRoute
  '/locations': typeof LocationsIndexRoute
  '/players': typeof PlayersIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/shames': typeof ShamesIndexRoute
  '/games/$gameId/sessions': typeof GamesGameIdSessionsRoute
  '/games/$gameId/update': typeof GamesGameIdUpdateRoute
  '/games/import/start': typeof GamesImportStartRoute
  '/players/$playerId/sessions': typeof PlayersPlayerIdSessionsRoute
  '/sessions/new/$gameId': typeof SessionsNewGameIdRoute
  '/sessions/update/$sessionId': typeof SessionsUpdateSessionIdRoute
  '/games/import/list/$username': typeof GamesImportListUsernameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_bare': typeof BareRouteWithChildren
  '/_bare/auth-callback': typeof BareAuthCallbackRoute
  '/_bare/login': typeof BareLoginRoute
  '/_bare/rsvp': typeof BareRsvpRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/games/new': typeof GamesNewRoute
  '/players/$playerId': typeof PlayersPlayerIdRoute
  '/sessions/new': typeof SessionsNewRoute
  '/compare/': typeof CompareIndexRoute
  '/game-nights/': typeof GameNightsIndexRoute
  '/games/': typeof GamesIndexRoute
  '/loans/': typeof LoansIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/players/': typeof PlayersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shames/': typeof ShamesIndexRoute
  '/games/$gameId_/sessions': typeof GamesGameIdSessionsRoute
  '/games/$gameId_/update': typeof GamesGameIdUpdateRoute
  '/games/import/start': typeof GamesImportStartRoute
  '/players/$playerId_/sessions': typeof PlayersPlayerIdSessionsRoute
  '/sessions/new_/$gameId': typeof SessionsNewGameIdRoute
  '/sessions/update_/$sessionId': typeof SessionsUpdateSessionIdRoute
  '/games/import/list_/$username': typeof GamesImportListUsernameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-callback'
    | '/login'
    | '/rsvp'
    | '/games/$gameId'
    | '/games/new'
    | '/players/$playerId'
    | '/sessions/new'
    | '/compare/'
    | '/game-nights/'
    | '/games/'
    | '/loans/'
    | '/locations/'
    | '/players/'
    | '/settings/'
    | '/shames/'
    | '/games/$gameId/sessions'
    | '/games/$gameId/update'
    | '/games/import/start'
    | '/players/$playerId/sessions'
    | '/sessions/new/$gameId'
    | '/sessions/update/$sessionId'
    | '/games/import/list/$username'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-callback'
    | '/login'
    | '/rsvp'
    | '/games/$gameId'
    | '/games/new'
    | '/players/$playerId'
    | '/sessions/new'
    | '/compare'
    | '/game-nights'
    | '/games'
    | '/loans'
    | '/locations'
    | '/players'
    | '/settings'
    | '/shames'
    | '/games/$gameId/sessions'
    | '/games/$gameId/update'
    | '/games/import/start'
    | '/players/$playerId/sessions'
    | '/sessions/new/$gameId'
    | '/sessions/update/$sessionId'
    | '/games/import/list/$username'
  id:
    | '__root__'
    | '/'
    | '/_bare'
    | '/_bare/auth-callback'
    | '/_bare/login'
    | '/_bare/rsvp'
    | '/games/$gameId'
    | '/games/new'
    | '/players/$playerId'
    | '/sessions/new'
    | '/compare/'
    | '/game-nights/'
    | '/games/'
    | '/loans/'
    | '/locations/'
    | '/players/'
    | '/settings/'
    | '/shames/'
    | '/games/$gameId_/sessions'
    | '/games/$gameId_/update'
    | '/games/import/start'
    | '/players/$playerId_/sessions'
    | '/sessions/new_/$gameId'
    | '/sessions/update_/$sessionId'
    | '/games/import/list_/$username'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BareRoute: typeof BareRouteWithChildren
  GamesGameIdRoute: typeof GamesGameIdRoute
  GamesNewRoute: typeof GamesNewRoute
  PlayersPlayerIdRoute: typeof PlayersPlayerIdRoute
  SessionsNewRoute: typeof SessionsNewRoute
  CompareIndexRoute: typeof CompareIndexRoute
  GameNightsIndexRoute: typeof GameNightsIndexRoute
  GamesIndexRoute: typeof GamesIndexRoute
  LoansIndexRoute: typeof LoansIndexRoute
  LocationsIndexRoute: typeof LocationsIndexRoute
  PlayersIndexRoute: typeof PlayersIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  ShamesIndexRoute: typeof ShamesIndexRoute
  GamesGameIdSessionsRoute: typeof GamesGameIdSessionsRoute
  GamesGameIdUpdateRoute: typeof GamesGameIdUpdateRoute
  GamesImportStartRoute: typeof GamesImportStartRoute
  PlayersPlayerIdSessionsRoute: typeof PlayersPlayerIdSessionsRoute
  SessionsNewGameIdRoute: typeof SessionsNewGameIdRoute
  SessionsUpdateSessionIdRoute: typeof SessionsUpdateSessionIdRoute
  GamesImportListUsernameRoute: typeof GamesImportListUsernameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_bare': {
      id: '/_bare'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shames/': {
      id: '/shames/'
      path: '/shames'
      fullPath: '/shames/'
      preLoaderRoute: typeof ShamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/': {
      id: '/players/'
      path: '/players'
      fullPath: '/players/'
      preLoaderRoute: typeof PlayersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/': {
      id: '/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof LocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loans/': {
      id: '/loans/'
      path: '/loans'
      fullPath: '/loans/'
      preLoaderRoute: typeof LoansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game-nights/': {
      id: '/game-nights/'
      path: '/game-nights'
      fullPath: '/game-nights/'
      preLoaderRoute: typeof GameNightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/': {
      id: '/compare/'
      path: '/compare'
      fullPath: '/compare/'
      preLoaderRoute: typeof CompareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/new': {
      id: '/sessions/new'
      path: '/sessions/new'
      fullPath: '/sessions/new'
      preLoaderRoute: typeof SessionsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/$playerId': {
      id: '/players/$playerId'
      path: '/players/$playerId'
      fullPath: '/players/$playerId'
      preLoaderRoute: typeof PlayersPlayerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/new': {
      id: '/games/new'
      path: '/games/new'
      fullPath: '/games/new'
      preLoaderRoute: typeof GamesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameId': {
      id: '/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof GamesGameIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_bare/rsvp': {
      id: '/_bare/rsvp'
      path: '/rsvp'
      fullPath: '/rsvp'
      preLoaderRoute: typeof BareRsvpRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/login': {
      id: '/_bare/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof BareLoginRouteImport
      parentRoute: typeof BareRoute
    }
    '/_bare/auth-callback': {
      id: '/_bare/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof BareAuthCallbackRouteImport
      parentRoute: typeof BareRoute
    }
    '/sessions/update_/$sessionId': {
      id: '/sessions/update_/$sessionId'
      path: '/sessions/update/$sessionId'
      fullPath: '/sessions/update/$sessionId'
      preLoaderRoute: typeof SessionsUpdateSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/new_/$gameId': {
      id: '/sessions/new_/$gameId'
      path: '/sessions/new/$gameId'
      fullPath: '/sessions/new/$gameId'
      preLoaderRoute: typeof SessionsNewGameIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/players/$playerId_/sessions': {
      id: '/players/$playerId_/sessions'
      path: '/players/$playerId/sessions'
      fullPath: '/players/$playerId/sessions'
      preLoaderRoute: typeof PlayersPlayerIdSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/import/start': {
      id: '/games/import/start'
      path: '/games/import/start'
      fullPath: '/games/import/start'
      preLoaderRoute: typeof GamesImportStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameId_/update': {
      id: '/games/$gameId_/update'
      path: '/games/$gameId/update'
      fullPath: '/games/$gameId/update'
      preLoaderRoute: typeof GamesGameIdUpdateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameId_/sessions': {
      id: '/games/$gameId_/sessions'
      path: '/games/$gameId/sessions'
      fullPath: '/games/$gameId/sessions'
      preLoaderRoute: typeof GamesGameIdSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/import/list_/$username': {
      id: '/games/import/list_/$username'
      path: '/games/import/list/$username'
      fullPath: '/games/import/list/$username'
      preLoaderRoute: typeof GamesImportListUsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface BareRouteChildren {
  BareAuthCallbackRoute: typeof BareAuthCallbackRoute
  BareLoginRoute: typeof BareLoginRoute
  BareRsvpRoute: typeof BareRsvpRoute
}

const BareRouteChildren: BareRouteChildren = {
  BareAuthCallbackRoute: BareAuthCallbackRoute,
  BareLoginRoute: BareLoginRoute,
  BareRsvpRoute: BareRsvpRoute,
}

const BareRouteWithChildren = BareRoute._addFileChildren(BareRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BareRoute: BareRouteWithChildren,
  GamesGameIdRoute: GamesGameIdRoute,
  GamesNewRoute: GamesNewRoute,
  PlayersPlayerIdRoute: PlayersPlayerIdRoute,
  SessionsNewRoute: SessionsNewRoute,
  CompareIndexRoute: CompareIndexRoute,
  GameNightsIndexRoute: GameNightsIndexRoute,
  GamesIndexRoute: GamesIndexRoute,
  LoansIndexRoute: LoansIndexRoute,
  LocationsIndexRoute: LocationsIndexRoute,
  PlayersIndexRoute: PlayersIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  ShamesIndexRoute: ShamesIndexRoute,
  GamesGameIdSessionsRoute: GamesGameIdSessionsRoute,
  GamesGameIdUpdateRoute: GamesGameIdUpdateRoute,
  GamesImportStartRoute: GamesImportStartRoute,
  PlayersPlayerIdSessionsRoute: PlayersPlayerIdSessionsRoute,
  SessionsNewGameIdRoute: SessionsNewGameIdRoute,
  SessionsUpdateSessionIdRoute: SessionsUpdateSessionIdRoute,
  GamesImportListUsernameRoute: GamesImportListUsernameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
